import useIsModal from 'hooks/useIsModal';
import useSearchParams from 'hooks/useSearchParams';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Modal from '~/reusable-components/dialogs/Modal';
import ModalHeader from '~/reusable-components/dialogs/Modal/ModalHeader';
import Section from '~/reusable-components/layout/Section';

const CSS = require('./ModalPage.module.scss');

interface ModalPageProps {
  title: React.ReactNode;
  isWide?: boolean;
  children: React.ReactNode;
  hideBackButton?: boolean;
}

function ModalPage({
  children,
  title,
  isWide,
  hideBackButton,
}: ModalPageProps) {
  const isModal = useIsModal();
  const history = useHistory();
  const location = useLocation<{ modal: boolean }>();
  const searchParams = useSearchParams();

  if (isModal) {
    return (
      <Modal
        title={title}
        onClose={history.goBack}
        fullscreen="mobile"
        isWide={isWide}
      >
        {children}
      </Modal>
    );
  }

  const returnTo = searchParams.get('returnTo') || '/';
  const onBack = () =>
    location.state?.modal ? history.goBack() : history.replace(returnTo);

  return (
    <>
      <Section
        as="header"
        isNarrow={!isWide}
        noSpace="all"
        variant="sandstone"
        noPadding
      >
        <ModalHeader
          title={title}
          onBack={hideBackButton ? undefined : onBack}
          isPageHeader
        />
      </Section>
      <Section isNarrow={!isWide} noSpace="all">
        <div className={CSS.PageContent}>{children}</div>
      </Section>
    </>
  );
}

export default ModalPage;
